import React from "react";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
var TocStockHeader = function (props) {
    var device = DeviceContext();
    return (React.createElement("div", { className: "toc stock-details-head bg_aqua_white ".concat(!(device === null || device === void 0 ? void 0 : device.isDesktop) && "w-100 ") }, props.children));
};
export default TocStockHeader;
